import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {UserInputComponent} from '../user-input/user-input.component';
import {PostDataService} from '../../services/post-data.service';
import firebase from '../../../firebase.js';
import {environment} from '../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
	public fileName: string;

	constructor(public dialog: MatDialog, public postDataService: PostDataService, public formBuilder: FormBuilder, private snackBar: MatSnackBar) {
	}

	imageURLFeeReceipt: any;
	file: File;
	onSubmitClicked = false;

	state = ['Andhra Pradesh',
		'Arunachal Pradesh',
		'Assam',
		'Bihar',
		'Chhattisgarh',
		'Goa',
		'Gujarat',
		'Haryana',
		'Himachal Pradesh',
		'Jammu and Kashmir',
		'Jharkhand',
		'Karnataka',
		'Kerala',
		'Madhya Pradesh',
		'Maharashtra',
		'Manipur',
		'Meghalaya',
		'Mizoram',
		'Nagaland',
		'Odisha',
		'Punjab',
		'Rajasthan',
		'Sikkim',
		'Tamil Nadu',
		'Telangana',
		'Tripura',
		'Uttarakhand',
		'Uttar Pradesh',
		'West Bengal',
		'Andaman and Nicobar Islands',
		'Chandigarh',
		'Dadra and Nagar Haveli',
		'Daman and Diu',
		'Delhi',
		'Lakshadweep',
		'Puducherry'];

	instituteDetails = new FormGroup({
		InstituteName: new FormControl(' ', [Validators.required, this.noWhitespaceValidator]),
		InstituteCity: new FormControl(' ', [Validators.required, this.noWhitespaceValidator]),
		InstituteEmail: new FormControl(' ', [Validators.required, Validators.email, this.noWhitespaceValidator]),
		InstitutePin: new FormControl(' ', [Validators.required, Validators.minLength(6), Validators.maxLength(6), this.noWhitespaceValidator]),
		InstituteChequeNumber: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
		InstituteState: new FormControl(' ', [Validators.required]),
	});


	ngOnInit() {
	}

	onChangeHandler(value: string) {
		console.log(value);
	}

	preview2(files: FileList, $event: Event) {
		this.file = files[0];
		this.fileName = this.file.name;
	}

	openUserInput() {
		const dialogRef = this.dialog.open(UserInputComponent, {
			width: '70%',
			height: '100%',
			backdropClass: 'backdropBackground'
		});
	}

	submitForm() {
		this.onSubmitClicked = true;

		if (this.file) {
			const ref = firebase.storage().ref(`cheques/${this.file.name}`);
			ref.put(this.file)
				.then(() => {
					return ref.getDownloadURL()
						.then(url => {
							this.postDataService.instituteData.chequeImgUrl = url;
							const headers = new Headers();
							headers.append('Authorization', `Bearer ${environment.token}`);
							headers.append('Content-Type', 'application/json');

							return fetch('https://satpc-bulk.herokuapp.com/register', {
								method: 'POST',
								headers,
								body: JSON.stringify(this.postDataService.instituteData)
							}).then(res => res.json())
								.then(data => {
									if (data.status === 'success') {
										this.instituteDetails.reset();
										this.openSnackBar(data.message, data.status);
										this.onSubmitClicked = false;
										this.postDataService.instituteData = {
											...this.postDataService.resetInstitute,
											students: [...this.postDataService.resetInstitute.students]
										};
										this.postDataService.student = {...this.postDataService.resetStudent};
										this.fileName = null;
										this.file = null;
									} else {
										this.openSnackBar(data.message, data.status);
										this.onSubmitClicked = false;
									}
								});
						});
				})
				.catch(error => {
					this.onSubmitClicked = false;
					this.openSnackBar(error.message, error.success);

				});
		} else {
			const headers = new Headers();
			headers.append('Authorization', `Bearer ${environment.token}`);
			headers.append('Content-Type', 'application/json');

			return fetch('https://satpc-bulk.herokuapp.com/register', {
				method: 'POST',
				headers,
				body: JSON.stringify(this.postDataService.instituteData)
			}).then(res => res.json())
				.then(data => {
					if (data.status === "success") {
						this.openSnackBar(data.message, data.success);
						this.instituteDetails.reset();
						this.postDataService.instituteData = {
							...this.postDataService.resetInstitute,
							students: [...this.postDataService.resetInstitute.students]
						};
						this.postDataService.student = {...this.postDataService.resetStudent};

						this.onSubmitClicked = false;
						this.fileName = null;
						this.file = null;
					} else {
						this.openSnackBar(data.message, data.status);
						this.onSubmitClicked = false;
					}
				})
				.catch(error => {
					this.onSubmitClicked = false;
					this.openSnackBar(error.message, error.success);
				});
		}
	}

	onChangeInstituteEmail(event: string) {
		this.postDataService.instituteData.instituteEmail = event;
		this.instituteDetails.controls.InstituteEmail.setValue(event);
	}

	onChangeInstituteCode(event: string) {
		this.postDataService.instituteData.institutePin = event;
		this.instituteDetails.controls.InstitutePin.setValue(event);
	}

	onChangeInsituteCity(event: string) {
		this.postDataService.instituteData.instituteCity = event;
		this.instituteDetails.controls.InstituteCity.setValue(event);


	}

	onChangeInstituteName(event: string) {
		this.postDataService.instituteData.instituteName = event;
		this.instituteDetails.controls.InstituteName.setValue(event);

	}

	onChangeInstituteState(event: string) {
		this.postDataService.instituteData.instituteState = event;
		this.instituteDetails.controls.InstituteState.setValue(event);

	}

	onChangeChequeNumber(event: string) {
		this.postDataService.instituteData.chequeNumber = event;
		this.instituteDetails.controls.InstituteChequeNumber.setValue(event);
	}

	onClickEdit(element, index) {
		this.postDataService.student = element;
		this.openUserInput();
		this.postDataService.EditModeSubject.next(true);
		this.postDataService.editStudentDetails = index;
	}

	onClickDelete(element, index) {
		this.postDataService.instituteData.students = this.postDataService.instituteData.students.filter((value, elementIndex) => index !== elementIndex);
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 2000,
		});
	}

	public noWhitespaceValidator(control: FormControl) {
		const isWhitespace = (control.value || '').trim().length === 0;
		const isValid = !isWhitespace;
		return isValid ? null : {'whitespace': true};
	}
}
